import { Component, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoPipe } from '@ngneat/transloco';
import { RouteFormDateSelectorComponent } from './components';
import { RouteFormDateSelectorService } from './services';
import { RouteFormMoreOptionsComponent } from './components/route-form-more-options/route-form-more-options.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-route-form-options-panels',
  standalone: true,
  imports: [CommonModule, MatTabsModule, TranslocoPipe, RouteFormDateSelectorComponent, RouteFormMoreOptionsComponent, MatIconModule],
  templateUrl: './route-form-options-panels.component.html',
  styleUrls: ['./route-form-options-panels.component.scss']
})
export class RouteFormOptionsPanelsComponent {

  public selectedTabIndex = 1;
  private previousIndex = 1;
  public optionToLeaveSelected = inject(RouteFormDateSelectorService).getDateOptionSelected();

  public tabClick(event: any) {
    const classList = (event.target as HTMLElement).classList
    if( !classList.contains('mdc-tab__text-label') && !classList.contains('mdc-tab') && !classList.contains('mdc-tab__content') && !classList.contains('tab-icon')) {
      return;
    }
    if (this.selectedTabIndex === this.previousIndex) {
      this.selectedTabIndex = 0;
      this.previousIndex = 0;
    } else {
      this.previousIndex = this.selectedTabIndex;
    }
  }
}
